<template>
  <div id="studentSchedule">
    <v-container fluid class="student-calendar">
      <h2 class="section-title text-center">{{ $t("Appointments") }}</h2>
      <v-row>
        <v-col cols="12" sm="2">
          <div class="details text-center">
            <img
              :src="
                studentObject.img != ''
                  ? studentObject.img
                  : studentObject.gender == 'male'
                  ? defaultAvaterMale
                  : defaultAvaterfeMale
              "
              class="thumbnial"
            />
            <v-file-input
              style="display: none"
              id="avatar"
              @change="onAddFile"
              accept="image/*"
            ></v-file-input>
            <p class="text-center teacher-name">
              <span class="main-color">{{ studentObject.name }}</span>
              <v-icon color="success">fiber_manual_record</v-icon>
            </p>
            <p class="title second-color">{{ $t("student") }}</p>
            <p class="rate-starts text-center" v-if="count >= 3">
              <v-icon :color="studentObject.rating >= 1 ? '#FDCD25' : '#bfbfbf'"
                >star_rate</v-icon
              >
              <v-icon :color="studentObject.rating >= 2 ? '#FDCD25' : '#bfbfbf'"
                >star_rate</v-icon
              >
              <v-icon :color="studentObject.rating >= 3 ? '#FDCD25' : '#bfbfbf'"
                >star_rate</v-icon
              >
              <v-icon :color="studentObject.rating >= 4 ? '#FDCD25' : '#bfbfbf'"
                >star_rate</v-icon
              >
              <v-icon :color="studentObject.rating >= 5 ? '#FDCD25' : '#bfbfbf'"
                >star_rate</v-icon
              >
            </p>
          </div>
          <div class="student-info">
            <p class="main-color">
              <v-icon class="main-color">book</v-icon>
              <span>{{ studentObject.grade }}</span>
            </p>
            <p class="main-color">
              <v-icon class="main-color">language</v-icon>
              <span>{{ studentObject.curriculum }}</span>
            </p>
          </div>
          <div class="text-center">
            <v-btn class="editbtn" to="/student/profilesettings?edit=true">
              <v-icon class="second-color">edit</v-icon>{{ $t("editInfo") }}
            </v-btn>
          </div>
          <v-divider></v-divider>

          <div class="lessonsChart">
            <p class="main-color subjectChart-title text-center">
              {{ $t("my lessons") }}
            </p>

            <div id="app">
              <canvas id="planet-chart" width="500" height="300"></canvas>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="8">
          <v-row class="fill-height">
            <v-col>
              <studentCalendarComponent></studentCalendarComponent>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" v-if="count >= 3">
          <div class="rateSection">
            <h3 class="main-color">
              <strong>{{ $t("teacherEvaluation") }}</strong>
            </h3>
            <div
              class="rating"
              v-for="(item, index) in ratingArray"
              :key="index"
            >
              <div class="item">
                <p class="main-color rating-item">
                  {{ item.question }}
                  <span
                    class="rating-count ratingCount"
                    :class="
                      locale == 'en' ? 'ratingCount-ltr' : 'ratingCount-rtl'
                    "
                  >
                    {{ item.count }}
                  </span>
                </p>
                <div class="rate">
                  <v-icon :color="item.avg_rating >= 1 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon :color="item.avg_rating >= 2 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon :color="item.avg_rating >= 3 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon :color="item.avg_rating >= 4 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon :color="item.avg_rating >= 5 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                </div>
              </div>
            </div>
          </div>
          <v-divider></v-divider>

          <div class="chart">
            <v-select
              solo
              class="custom-select"
              :items="questions"
              item-text="text"
              item-value="id"
              v-model="selectedQuestion"
              @change="getChartData"
            ></v-select>

            <div id="app">
              <!-- <canvas id="planet-chart"></canvas> -->
              <canvas
                id="rating-chart"
                dir="rtl"
                width="500"
                height="300"
              ></canvas>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Chart from "chart.js";
import studentCalendarComponent from "../../components/studentCalendarComponent";

export default {
  name: "studentProfile",
  components: {
    studentCalendarComponent
  },
  data: () => ({
    subjectsData: [],
    subjectsColors: [],
    subjectsLabel: [],
    subjectsTotal: "",
    subjectsChartData: [],
    chartData: [],
    questions: [],
    selectedQuestion: "",
    defaultImg: require("../../assets/images/women.png"),
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days"
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],

    count: 0,
    ratingArray: [],
    studentObject: {
      name: "",
      img: "",
      gender: "",
      rating: "",
      grade: "",
      curriculum: ""
    },
    chart: ""
  }),
  methods: {
    createBarChart() {
      /*-------------------------------------
          bar Chart 
      -------------------------------------*/
      const ratingChart = document
        .getElementById("rating-chart")
        .getContext("2d");

      if (this.chart) {
        this.chart.destroy();
      }

      // eslint-disable-next-line no-unused-vars
      this.chart = new Chart(ratingChart, {
        type: "bar", // "bar", "horizontalBar", "doughnut", "line", "pie", "radar", "polarArea"
        data: {
          labels: [
            "\uf005",
            "\uf005 \uf005",
            "\uf005 \uf005 \uf005",
            "\uf005 \uf005 \uf005 \uf005",
            "\uf005 \uf005 \uf005 \uf005 \uf005"
          ],
          backgroundColor: [
            "#FFB400",
            "#FFB400",
            "#FFB400",
            "#FFB400",
            "#FFB400",
            "#FFB400"
          ],
          datasets: [
            {
              label: this.$i18n.t("Rating"),
              barThickness: 10,
              data: this.chartData,
              backgroundColor: [
                "#187E89",
                "#187E89",
                "#187E89",
                "#187E89",
                "#187E89",
                "#187E89"
              ],
              borderColor: [
                "#187E89",
                "#187E89",
                "#187E89",
                "#187E89",
                "#187E89",
                "#187E89"
              ]
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          // hover: { mode: null },

          scales: {
            xAxes: [
              {
                ticks: {
                  padding: 20,
                  fontFamily: "FontAwesome",
                  autoSkip: false,
                  maxRotation: 90,
                  minRotation: 90,
                  fontColor: "#FFB400",
                  reverse: this.locale == "en" ? false : true
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  userCallback: function(label, index, labels) {
                    // when the floored value is the same as the value we have a whole number
                    if (Math.floor(label) === label) {
                      return label;
                    }
                  }
                },
                position: this.locale == "en" ? "left" : "right"
              }
            ]
          },
          legend: {
            display: true
          },
          tooltips: {
            enabled: true,
            titleFontFamily: "FontAwesome",
            bodyFontFamily: "FontAwesome"
          }
        }
      });
    },

    createDoughnutChart() {
      /*-------------------------------------
          doughnut Chart 
      -------------------------------------*/
      const myChart = document.getElementById("planet-chart").getContext("2d");
      const total = this.subjectsTotal;
      const title = this.$i18n.t("subjects_");

      // eslint-disable-next-line no-unused-vars
      const masschart = new Chart(myChart, {
        type: "doughnut", // "bar", "horizontalBar", "doughnut", "line", "pie", "radar", "polarArea"
        data: {
          datasets: [
            {
              backgroundColor: this.subjectsColors,
              data: this.subjectsData
            }
          ],

          // These labels appear in the legend and in the tooltips when hovering different arcs
          labels: this.subjectsLabel
        },
        plugins: [
          {
            beforeDraw: function(chart) {
              if (chart.config.options.elements.center) {
                // Get ctx from string
                const ctx = chart.chart.ctx;

                // Get options from the center object in options
                const centerConfig = chart.config.options.elements.center;
                const fontStyle = centerConfig.fontStyle || "Arial";
                const txt = total + " " + title;
                const color = centerConfig.color || "#000";
                const maxFontSize = centerConfig.maxFontSize || 75;
                const sidePadding = centerConfig.sidePadding || 20;
                const sidePaddingCalculated =
                  (sidePadding / 100) * (chart.innerRadius * 2);
                // Start with a base font of 30px
                ctx.font = "30px " + fontStyle;

                // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                const stringWidth = ctx.measureText(txt).width;
                const elementWidth =
                  chart.innerRadius * 2 - sidePaddingCalculated;

                // Find out how much the font can grow in width.
                const widthRatio = elementWidth / stringWidth;
                const newFontSize = Math.floor(30 * widthRatio);
                const elementHeight = chart.innerRadius * 2;

                // Pick a new font size so it will not be larger than the height of label.
                let fontSizeToUse = Math.min(
                  newFontSize,
                  elementHeight,
                  maxFontSize
                );
                let minFontSize = centerConfig.minFontSize;
                const lineHeight = centerConfig.lineHeight || 25;
                let wrapText = false;

                if (minFontSize === undefined) {
                  minFontSize = 20;
                }

                if (minFontSize && fontSizeToUse < minFontSize) {
                  fontSizeToUse = minFontSize;
                  wrapText = true;
                }

                // Set font settings to draw it correctly.
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                const centerX =
                  (chart.chartArea.left + chart.chartArea.right) / 2;
                let centerY =
                  (chart.chartArea.top + chart.chartArea.bottom) / 2;
                ctx.font = fontSizeToUse + "px " + fontStyle;
                ctx.fillStyle = color;

                if (!wrapText) {
                  ctx.fillText(txt, centerX, centerY);
                  return;
                }

                const words = txt.split(" ");
                let line = "";
                const lines = [];

                // Break words up into multiple lines if necessary
                for (let n = 0; n < words.length; n++) {
                  const testLine = line + words[n] + " ";
                  const metrics = ctx.measureText(testLine);
                  const testWidth = metrics.width;
                  if (testWidth > elementWidth && n > 0) {
                    lines.push(line);
                    line = words[n] + " ";
                  } else {
                    line = testLine;
                  }
                }

                // Move the center up depending on line height and number of lines
                centerY -= (lines.length / 2) * lineHeight;

                for (let n = 0; n < lines.length; n++) {
                  ctx.fillText(lines[n], centerX, centerY);
                  centerY += lineHeight;
                }
                //Draw text in center
                ctx.fillText(line, centerX, centerY);
              }
            }
          }
        ],
        options: {
          responsive: true,
          maintainAspectRatio: false,

          animation: {
            duration: 1000
          },
          legend: {
            display: true
          },
          tooltips: {
            enabled: true
          },
          elements: {
            center: {
              color: "#FF6384", // Default is #000000
              fontStyle: "Arial", // Default is Arial
              sidePadding: 20, // Default is 20 (as a percentage)
              minFontSize: 25, // Default is 20 (in px), set to false and text will not wrap.
              lineHeight: 25 // Default is 25 (in px), used for when text wraps
            }
          }
        }
      });
    },

    getChartData() {
      this.$http
        .get(
          this.getApiUrl + "/student/teacher_ratings/" + this.selectedQuestion,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          console.log(response);
          if (response.data.status.error == false) {
            this.chartData = response.data.data;
            this.createBarChart();
          }
        });
    },

    getSubjectChartData() {
      this.$http
        .get(this.getApiUrl + "/student/subjects/statistics", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          console.log(response);
          if (response.data.status.error == false) {
            console.log(response.data.data);
            this.subjectsData = response.data.data.data;
            this.subjectsColors = response.data.data.backgroundColor;
            this.subjectsLabel = response.data.data.labels;
            this.subjectsTotal = response.data.data.total;
            this.createDoughnutChart();
          }
        });
    },
    profile() {
      this.$http
        .get(this.getApiUrl + "/student/profile", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.studentObject.name = response.data.data.name;
            this.studentObject.img = response.data.data.img;
            this.studentObject.gender = response.data.data.gender;
            this.studentObject.rating = response.data.data.rating;
            this.studentObject.grade = response.data.data.grade;
            this.studentObject.curriculum = response.data.data.curriculum;
          }
        });
    },
    getRating() {
      this.$http
        .get(this.getApiUrl + "/student/evaluation", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            // console.log(response);
            this.ratingObject = response.data.data;
            this.count = response.data.data.count;
            this.ratingArray = response.data.data.data;
            this.questions = response.data.data.questions;
            this.selectedQuestion = this.questions[0].id;

            this.getChartData();
          }
        });
    },
    selectFile() {
      document.getElementById("avatar").click();
    },
    onAddFile(File) {
      if (File) {
        const selectedImage = File;
        const data = new FormData();
        data.set("avatar", selectedImage);
        this.$http
          .post(this.getApiUrl + "/user/avatar", data, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          })
          .then(response => {
            if (response.data.status.error == false) {
              this.studentObject.img = response.data.data.path;
            }
          });
      }
    }
  },
  mounted() {
    this.profile();
    this.getRating();
    this.getSubjectChartData();
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

.details {
  p {
    margin-bottom: 0;
  }
}

.student-info {
  margin-right: 2rem !important;
  p {
    margin-bottom: 0;
    font-size: 0.8rem !important;
  }
}

.editbtn {
  background-color: transparent;
  border: 1px solid $second-color;
  color: $second-color;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.rateSection {
  .rating {
    margin-top: $margin-top;
    margin-bottom: $margin-bottom;
    .item {
      margin-bottom: 5px;
      p {
        margin-bottom: 0;
      }
    }
  }
}

.chart {
  margin-top: 1rem;
}

.student-calendar {
  padding: 0 3rem !important;
}

.subjectChart-title {
  font-size: 1.5rem !important;
  margin-top: 1rem !important;
  font-weight: bold;
}

.rating-item {
  position: relative;
  .ratingCount {
    display: inline-block;
    position: absolute;
  }

  .ratingCount-ltr {
    right: 0;
  }
  .ratingCount-rtl {
    left: 0;
  }
}
</style>
